import { render, staticRenderFns } from "./checkOrder.vue?vue&type=template&id=20432190&scoped=true&"
import script from "./checkOrder.vue?vue&type=script&lang=js&"
export * from "./checkOrder.vue?vue&type=script&lang=js&"
import style0 from "./checkOrder.vue?vue&type=style&index=0&id=20432190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20432190",
  null
  
)

export default component.exports